import { api, fileUrl } from "./api";
import { decisionPDFBlob } from "./decisionPrint";

// Saves the sent decision as PDF to the company library + employee file (once per decision).
export async function archiveSentDecision(d, company, replace = false) {
  if (d.sent_archived_file_id && !replace) return { ok: true, already: true };
  const title = d.title || "قرار";
  const empName = d.employee_name || "";
  const pdfName = `${title.slice(0, 40)}${empName ? ` - ${empName}` : ""}.pdf`;
  const name = `${/^قرار/.test(title) ? "" : "قرار "}${title}${empName ? ` - ${empName}` : ""}`.trim();
  const blob = await decisionPDFBlob(d, company, fileUrl);
  const up = await api.uploadFile(new File([blob], pdfName, { type: "application/pdf" }));
  return api.archiveDecision({ file_id: up.attachment_id, file_name: pdfName, name, employee_id: d.employee_id || null, decision_id: d.id, replace });
}
